<template>
  <div class="container">

    <div class="entity-header">
      <div class="entity-title">{{ club.name }}</div>
      <div class="entity-details">{{ $t('clubs.federation') }} : {{club.federationCode}}</div>
      <div class="entity-details">{{ $t('clubs.code') }} : {{club.code}}</div>
    </div>

    <section>
      <tournaments-list class="results-area" :tournaments="tournaments" :listType="'Table'"></tournaments-list>
      <div v-if="tournaments.length == 0">Er zijn nog geen toernooien door deze club georganiseerd via chess administrator. </div>    
    </section>

    <section>
      <persons-list v-if="people.length != 0" 
          :persons="people" 
          :listType="'Table'"
          :optionSelectAll="false"></persons-list>
    </section>    
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import TournamentsList from "@/components/tournaments/TournamentsList";
import PersonsList from "@/components/players/PersonsList";


const apiName = 'api';
const myInit = {
  response: false, 
};

export default {
  name: 'ClubDetails',
  components: {TournamentsList, PersonsList},
  props: {
    clubId: String
  },
  data: function () {
    return {
      club: {},
      people: [],
      tournaments: [],
      playerIcon: require('../../assets/img/CA_Player_black.png'),
    }
  },
  computed: {
    memberCount() {
      return this.people.length;
    }
  },
  beforeMount() {
    this.loadClub();
    this.loadClubMembers();
    this.loadClubTournaments();
  },
  methods: {
    loadClub: function() {
      let that = this
      let path = '/club/' + this.$route.params.clubId
      console.log("club: " + path)
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.club = response
          this.$CA_Storage.setVisit("club", this.$route.params.clubId, that.club.name);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadClubMembers: function () {
      let that = this
      let path = '/person?clubId=' + this.$route.params.clubId
      console.log("members: " + path)
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.people = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadClubTournaments: function () {
      let that = this
      let path = '/tournament?clubId=' + this.$route.params.clubId
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.tournaments = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

section {
  padding-top: 20px;
}

.results-area {
  max-width: 800px; 
  width: 100%;
  overflow-x: auto;
}

.container {
  width: 100%;
  padding: 1vw;
  box-sizing: border-box;
}

/* mobile */
@media screen and (max-width: 600px) {
  .results-area {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
  
  .container {
    width: 98vw;
    padding: 2vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .results-area {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
  
  .container {
    width: 95vw;
    padding: 1.5vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .results-area {
    max-width: 800px;
    min-width: 0;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
}

</style>
